import { EnrollmentExperienceResponse } from "@/api/types";
import { EnrollmentState } from "./state";


export interface SetWhitelabelDataAction {
  readonly type: "SET_WHITELABEL_DATA";
  readonly payload: EnrollmentExperienceResponse;
}

export interface SetLoadingAction {
  readonly type: "SET_LOADING";
  readonly payload: boolean;
}


export type EnrollmentAction = SetWhitelabelDataAction | SetLoadingAction;


export const enrollmentReducer = (state: EnrollmentState, action: EnrollmentAction): EnrollmentState => {
  switch (action.type) {
    case "SET_WHITELABEL_DATA":
      return handelSetWhitelabelData(state, action);
    case "SET_LOADING":
      return handleSetLoading(state, action);
    default:
      throw Error(`Action ${action} unknown`);
  }
};


function handelSetWhitelabelData(state: EnrollmentState, action: SetWhitelabelDataAction): EnrollmentState {
  return {
    ...state,
    experienceData: { ...action.payload },
  };
}


function handleSetLoading(state: EnrollmentState, action: SetLoadingAction): EnrollmentState {
  return {
    ...state,
    isLoading: action.payload,
  };
}
